module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 shippingCostsTable"
  }, [_vm._m(0), _vm._v(" "), _c('shipping-cost-row', {
    attrs: {
      "name": "total",
      "label": "Total:",
      "data": _vm.totals.total
    }
  }), _vm._v(" "), _c('shipping-cost-row', {
    attrs: {
      "name": "standard",
      "data": _vm.totals.standard
    }
  }), _vm._v(" "), _c('shipping-cost-row', {
    attrs: {
      "name": "overnight",
      "data": _vm.totals.overnight
    }
  }), _vm._v(" "), _c('shipping-cost-row', {
    attrs: {
      "name": "expedited",
      "icon": "expeditedOne",
      "data": _vm.totals.expedited
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('line-chart', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "chartdata": _vm.chartdata,
      "options": _vm.options
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header",
    staticStyle: {
      "height": "20px",
      "padding-left": "15px"
    }
  }, [_c('div', {
    staticClass: "col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Last 30 Days")])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Monthly Average")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9e6048a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/ShippingCostWidget.vue
// module id = 775
// module chunks = 0